import { render, staticRenderFns } from "./insStock.vue?vue&type=template&id=033993a0&"
import script from "./insStock.vue?vue&type=script&lang=js&"
export * from "./insStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports